import { render, staticRenderFns } from "./multiCheckProperty.vue?vue&type=template&id=1447d9a2"
import script from "./multiCheckProperty.vue?vue&type=script&lang=js"
export * from "./multiCheckProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports